'use client'

import styled from 'styled-components'
import {getColor} from "@/pipes/theme.pipe";

export default styled.label`
  width: 100%;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: ${getColor('primary')} !important;
  margin-bottom: 0.25rem;
  margin-left: 11px;
  display: flex;
  align-items: center;
  //opacity: ${(props) => props.disabled && '0.75'};

  & svg {
    margin-right: 0.5rem;

    &:last-child {
      margin-left: 0.25rem;
    }
  }

  & .ant-checkbox-wrapper {
    margin-right: 0.5rem;
  }
`
